import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { debounce } from 'lodash';

@Component({
  selector: 'component-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent {
  textSearch: string = '';
  @Output() searchEvent = new EventEmitter<string>();

  debouncedSearch = debounce(
    event => this.searchAction(event.target.value),
    350
  );

  searchAction(text: any) {
    this.textSearch = text;
    this.searchEvent.emit(text);
  }

  clear() {
    this.textSearch = "";
    this.searchAction(this.textSearch);
  }
}
